import { render, staticRenderFns } from "./BlockedIp.vue?vue&type=template&id=f5c3f7e2&"
import script from "./BlockedIp.vue?vue&type=script&lang=js&"
export * from "./BlockedIp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports